export const styles = {
  tooltipContainer: {
    paddingRight: { xs: "16px", sm: "20px" },
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    overflow: "auto",
    maxHeight: "100%",
    minHeight: 0,
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
  },

  tooltipTitle: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "28px",
  },

  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
  },

  sectionTitle: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "160%",
  },

  sectionDescription: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "160%",
    whiteSpace: "pre-line",
  },

  moreInfoWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    width: "max-content",
  },

  moreInfoText: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "160%",
    color: "rgba(0, 85, 70, 1)",
    textDecoration: "underline",
  },

  moreInfoIcon: {
    height: "12px",
    width: "12px",
    cursor: "pointer",
  },

  tooltipPopper: {
    maxWidth: "476px",
    display: "flex",
    flexDirection: "column",
  },

  tooltipBox: {
    maxWidth: "100%",
    borderRadius: "8px",
    backgroundColor: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.16)",
    maxHeight: "min(628px, calc(100dvh - 104px))",
    display: "flex",
    flexDirection: "column",
    padding: { xs: "16px", sm: "32px" },
    paddingRight: { xs: "16px", sm: "16px" },
    mx: "12px",
  },

  tooltipArrow: {
    color: "rgba(255, 255, 255, 1)",
  },

  iconBase: (open) => ({
    height: "18px",
    width: "18px",
    cursor: "pointer",
    mask: "url(/icons/question-circle-filled-icon.svg) no-repeat center / contain",
    WebkitMask:
      "url(/icons/question-circle-filled-icon.svg) no-repeat center / contain",
    backgroundColor: open ? "rgba(37, 124, 109, 1)" : "rgba(72, 72, 72, 1)",
  }),
};
